import axios from 'axios';
import {redirectToLoginPage} from '../router/redirectToLoginPage';
import {extractApiRequestMainPath} from '../tracking/extractApiRequestMainPath';
import * as Sentry from "@sentry/vue";

const ignoredPages = ['/account/redtail', '/vessel/register', '/compliance-doc', '/register'];

export function addAxiosResponseInterceptor() {
  axios.interceptors.response.use(
    response => response,
    error => {
      const {method, url} = error.config || {};
      const path = extractApiRequestMainPath(url);

      if (error.response) {
        const {status} = error.response;

        if (status === 401 && ignoredPages.every(page => window.location.pathname.indexOf(page) < 0)) {
          redirectToLoginPage();
          return new Promise(() => {});
        }

        Sentry.captureException(new Error(`HTTP ${status}: ${method && method.toUpperCase()} ${path}`), { level: 'info'});
      } else if (error.request) {
        Sentry.captureException(new Error(`${method && method.toUpperCase()} ${path}`), { level: 'warning' });

        return new Promise(() => {});
      }

      return Promise.reject(error);
    }
  );
}
